/*
  Schwebende Produktleiste auf Mobile (Produktseite)
  --------------------------------------------------
  Sobald die Galerie aus dem Bild gescrollt ist, erscheint oben (unter dem Header) eine feste Karte mit dem aktuell
  gewählten Produktbild, Titel, Preis inkl. MwSt. und Bewertung. Tippen = zurück nach oben zur Galerie.

  Herkunft: Elevate-Test MC_PDP_FLOATINGPRODUCTBAR_LB24 („Floating Product Bar on Mobile PDPs“), hier als festes
  Theme-Feature im Karten-Look nachgebaut. Nur ≤ 699 px; nicht bei offenen Drawern/Modals, nicht bei Tastaturfokus
  in Eingabefeldern und nicht, wenn der Footer schon sichtbar ist. Konfigurator-Produkte werden im Layout ausgenommen.
  Markup/Styles: .cxfb in cx-refresh.css
*/
(function () {
  'use strict';
  if (!/\/products\/[^/]+\/?$/.test(location.pathname)) return;

  var mobile = matchMedia('(max-width: 699px)');
  var gallery, carousel, bar, img, titleEl, priceEl, taxEl, ratingEl, starsEl, countEl, section, galleryObserver, barAbort;
  var frame = 0, currentSrc = '', destroyed = false;

  var isVisible = function (el) { return !!el && !!el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden'; };
  var reduceMotion = function () { return matchMedia('(prefers-reduced-motion: reduce)').matches; };

  function hide() {
    if (!bar) return;
    bar.dataset.visible = 'false';
    bar.setAttribute('aria-hidden', 'true');
    bar.inert = true;
  }

  function teardown() {
    if (galleryObserver) galleryObserver.disconnect();
    if (barAbort) barAbort.abort();
    if (bar) bar.remove();
    gallery = carousel = bar = img = titleEl = priceEl = taxEl = ratingEl = starsEl = countEl = section = null;
    currentSrc = '';
  }

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }

  function build() {
    var found = Array.prototype.slice.call(document.querySelectorAll(
      'main .shopify-section--main-product product-gallery, main .shopify-section--main-product .mpv2__gallery, main .shopify-section--maison-product-hero product-gallery'
    )).filter(function (g) { return isVisible(g) && !g.closest('quick-buy-drawer, quick-buy-modal, [role="dialog"]'); })[0];
    if (found === gallery && bar && bar.isConnected) return;
    teardown();
    if (!found) return;
    gallery = found;
    section = gallery.closest('.shopify-section');
    carousel = gallery.querySelector('media-carousel, .mpv2-gal__main');
    if (!carousel) return;

    bar = el('button', 'cxfb');
    bar.type = 'button';
    bar.setAttribute('aria-label', 'Zurück zum Produkt');
    bar.setAttribute('aria-hidden', 'true');
    bar.inert = true;
    bar.dataset.visible = 'false';

    var media = el('span', 'cxfb__media');
    img = el('img');
    img.alt = '';
    img.decoding = 'async';
    media.appendChild(img);

    var body = el('span', 'cxfb__body');
    titleEl = el('span', 'cxfb__title');
    var priceRow = el('span', 'cxfb__price-row');
    priceEl = el('span', 'cxfb__price');
    taxEl = el('span', 'cxfb__tax');
    priceRow.appendChild(priceEl); priceRow.appendChild(taxEl);
    ratingEl = el('span', 'cxfb__rating');
    starsEl = el('span', 'cxfb__stars', '★★★★★');
    countEl = el('span', 'cxfb__count');
    ratingEl.appendChild(starsEl); ratingEl.appendChild(countEl);
    body.appendChild(titleEl); body.appendChild(priceRow); body.appendChild(ratingEl);
    body.setAttribute('aria-hidden', 'true');

    var up = el('span', 'cxfb__up');
    up.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor" aria-hidden="true"><path d="M440-160v-487L216-423l-56-57 320-320 320 320-56 57-224-224v487h-80Z"/></svg>';

    bar.appendChild(media); bar.appendChild(body); bar.appendChild(up);
    document.body.appendChild(bar);

    barAbort = new AbortController();
    var opts = { signal: barAbort.signal };
    bar.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduceMotion() ? 'instant' : 'smooth' });
    }, opts);
    ['carousel:change', 'carousel:settle', 'load'].forEach(function (name) {
      gallery.addEventListener(name, schedule, { signal: barAbort.signal, capture: true });
    });
    var form = document.forms[gallery.getAttribute('form')];
    if (form) form.addEventListener('variant:change', function () { currentSrc = ''; hide(); schedule(); }, opts);
    img.addEventListener('load', schedule, opts);
    img.addEventListener('error', hide, opts);
    galleryObserver = new MutationObserver(schedule);
    galleryObserver.observe(section || gallery, {
      subtree: true, childList: true, characterData: true, attributes: true,
      attributeFilter: ['src', 'srcset', 'hidden', 'class', 'aria-current', 'data-score', 'data-average-rating', 'data-number-of-reviews']
    });
  }

  function cleanText(node) {
    if (!node) return '';
    var copy = node.cloneNode(true);
    copy.querySelectorAll('.sr-only, [hidden]').forEach(function (n) { n.remove(); });
    return copy.textContent.replace(/\s+/g, ' ').trim();
  }

  function updateDetails() {
    var root = section || document;
    var price = root.querySelector('.product-info__price sale-price, .mpv2__price sale-price');
    if (!price) return false;
    var priceText = cleanText(price);
    if (!priceText) return false;
    if (priceEl.textContent !== priceText) priceEl.textContent = priceText;

    var title = cleanText(root.querySelector('.product-info__title, .mpv2__title, h1'));
    if (title && titleEl.textContent !== title) titleEl.textContent = title;

    var taxNode = root.querySelector('.product-info__price > .text-subdued, .mpv2__tax');
    if (!taxNode) {
      var wrap = price.closest('.product-info__price');
      taxNode = wrap && wrap.parentElement ? wrap.parentElement.querySelector(':scope > .text-subdued') : null;
    }
    var tax = cleanText(taxNode);
    if (taxEl.textContent !== tax) taxEl.textContent = tax;

    var badge = root.querySelector('.product-info .jdgm-prev-badge, .jdgm-prev-badge');
    var v2 = root.querySelector('.mpv2__rating');
    var score = Number(badge && badge.dataset.averageRating || (v2 && v2.getAttribute('aria-label') || '').replace(',', '.').split('/')[0]);
    var reviews = badge && badge.dataset.numberOfReviews;
    var count = Number(reviews) > 0 ? '(' + reviews + ')' : (v2 && v2.querySelector('.mpv2__rating-count') ? v2.querySelector('.mpv2__rating-count').textContent.trim() : '');
    ratingEl.hidden = !(score > 0 && score <= 5);
    starsEl.style.setProperty('--cxfb-fill', Math.min(100, Math.max(0, (score / 5) * 100)) + '%');
    if (countEl.textContent !== count) countEl.textContent = count;

    bar.setAttribute('aria-label', 'Zurück zum Produkt: ' + (title ? title + ', ' : '') + priceText + (tax ? ', ' + tax : '') + (score > 0 ? ', ' + score + ' von 5' : ''));
    return true;
  }

  function currentImage() {
    var slide = carousel.selectedSlide || carousel.querySelector('.swiper-slide-active') || carousel.querySelector('.product-gallery__media:not([hidden]), .swiper-slide');
    var node = slide && slide.querySelector(':scope > img');
    if (!node) node = gallery.querySelector('.product-gallery__media[data-media-type="image"]:not([hidden]) > img, .mpv2-gal__img');
    return node ? (node.currentSrc || node.getAttribute('src') || '') : '';
  }

  function stickyHeaderBottom() {
    var bottom = 0;
    document.querySelectorAll('body > header, .shopify-section-group-header-group').forEach(function (node) {
      var cs = getComputedStyle(node), rect = node.getBoundingClientRect();
      if ((cs.position === 'sticky' || cs.position === 'fixed') && isVisible(node) && rect.top <= (parseFloat(cs.top) || 0) + 1 && rect.bottom > 0) {
        bottom = Math.max(bottom, rect.bottom);
      }
    });
    return Math.ceil(bottom);
  }

  function somethingOpen() {
    var active = document.activeElement;
    if (active && active.matches('textarea, [contenteditable="true"], input:not([type="radio"]):not([type="checkbox"]):not([type="button"]):not([type="submit"]):not([type="hidden"]):not([type="range"])')) return true;
    return Array.prototype.some.call(document.querySelectorAll(
      'dialog[open], [role="dialog"][aria-modal="true"], cart-drawer[open], navigation-drawer[open], search-drawer[open], favorites-drawer[open], x-popover[open], x-modal[open], .pswp--open, .fcp24-zoom:not([hidden]), .cxs[data-cxs]:not([hidden])'
    ), isVisible);
  }

  function update() {
    frame = 0;
    if (destroyed) return;
    if (!mobile.matches) { teardown(); return; }
    build();
    if (!bar || !carousel || !isVisible(gallery)) { hide(); return; }
    var headerBottom = stickyHeaderBottom();
    var footer = document.querySelector('footer.shopify-section--footer, footer');
    if (gallery.getBoundingClientRect().bottom > headerBottom || somethingOpen() || (footer && footer.getBoundingClientRect().top < innerHeight)) { hide(); return; }
    var src = currentImage();
    if (!src || !updateDetails()) { hide(); return; }
    if (currentSrc !== src) { currentSrc = src; hide(); img.src = src; }
    bar.style.setProperty('--cxfb-top', headerBottom + 'px');
    var ready = img.complete && img.naturalWidth > 0;
    bar.dataset.visible = String(ready);
    bar.setAttribute('aria-hidden', String(!ready));
    bar.inert = !ready;
  }

  function schedule() {
    if (!destroyed && !frame) frame = requestAnimationFrame(update);
  }

  var bodyObserver = new MutationObserver(function (records) {
    if (records.some(function (r) { return !(r.target.closest && r.target.closest('.cxfb')); })) schedule();
  });

  function start() {
    if (destroyed) return;
    bodyObserver.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['open', 'hidden', 'aria-hidden', 'aria-modal'] });
    schedule();
  }

  var abort = new AbortController();
  var opts = { signal: abort.signal };
  window.addEventListener('scroll', schedule, { signal: abort.signal, passive: true });
  window.addEventListener('resize', schedule, opts);
  window.addEventListener('pageshow', schedule, opts);
  if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule, opts);
  mobile.addEventListener('change', schedule, opts);
  document.addEventListener('focusin', schedule, opts);
  document.addEventListener('focusout', schedule, opts);
  document.addEventListener('shopify:section:load', schedule, opts);
  document.addEventListener('shopify:section:unload', schedule, opts);

  window.cxFloatingBar = {
    destroy: function () { destroyed = true; abort.abort(); bodyObserver.disconnect(); cancelAnimationFrame(frame); teardown(); delete window.cxFloatingBar; }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { signal: abort.signal, once: true });
  else start();
})();
